import type { TranslationInterface } from './translation.types';

export const frLocale: TranslationInterface = {
  'write-a-message': 'Écrivez un message...',
  'session-closed-lead': 'Votre problème a été résolu !',
  'new-conversation': 'Nouvelle conversation',
  'welcome-title': 'Bienvenue dans notre chat de support',
  'welcome-description':
    'Nous sommes là pour vous aider ! Commencez une conversation et nous vous répondrons dès que possible.',
  'your-name': 'Votre nom',
  'your-email': 'Votre adresse e-mail',
  'start-chat': 'Parler au support',
  'starting-chat': 'Connexion...',
  'i-need-more-help': "Je besoin d'aide plus",
  'this-was-helpful': "C'était utile",
  optional: 'Optionnel',
  'no-conversations-yet': 'Aucune conversation pour le moment',
  'back-to-conversations': 'Retour aux conversations',
  'closed-conversations': 'Conversations fermées',
};
